<template>
  <div class="row">
    <div class="col-md-6">
      <input class="form-control" v-model="formData.name" placeholder="Enter name" />
      <input class="form-control" v-model="formData.email" type="email" placeholder="Enter email" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateLocationForm",
  data() {
    return {
      formData: {
        name: '',
      },
    };
  },
  methods: {
    // getFormData() {
    //   return this.formData;
    // },
    submitForm() {
      this.$emit('submit', this.formData);
    },
  },
};
</script>
